import * as React from 'react';

import cn from 'classnames';

type IRowProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const Row: React.FC<IRowProps> = ({ className, children }) => (
  <div className={cn('row', className)}>{children}</div>
);
